<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;">
				<s-header-top></s-header-top>
			</el-header>
			<el-header class="header">
				<s-header></s-header>
			</el-header>
			<el-main>				
				<div class="content">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<span style="float: left;">当前位置：</span>
						<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/policy' }">双创政策</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/policyDetail' }">详情</el-breadcrumb-item>
					</el-breadcrumb>
						
					<div class="page">
						<div class="page_body">
							<el-row class="name mar_bottom">{{item.title}}</el-row>
							<el-row class="mark top_lab_box mar_bottom">
								<el-col :span="12" class="mar_bottom10">政策来源：{{item.source}}</el-col>
								<el-col :span="12" class="mar_bottom10">发布时间：{{item.publishdate}}</el-col>
								<el-col :span="12">关键词：{{item.keyword}}</el-col>
							</el-row>
							<el-row class="remark mar_bottom">
								<p v-html='item.info'></p>
							</el-row>
							<el-row class="remark mar_bottom" v-if="item.files!=''">
								<el-col :span="24"  class="lab_hr"><div class="lab mar_bottom10">附件下载</div></el-col>
								<el-col :span="24">
									<el-link :underline="false" :href=" $imgBaseUrl+item.files" target="_blank">{{item.files.substring(item.files.lastIndexOf("/")+1)}}</el-link></el-col>
							</el-row>
						</div>
					</div>
				</div>
			</el-main>
			<el-footer class="footer">
				<s-footer></s-footer>
			</el-footer>
			<el-footer class="copy-right">
				<s-copyRight></s-copyRight>
			</el-footer>
		</el-scrollbar>
	</el-container>	
</template>

<script>
import sHeaderTop from '@/components/header_top'
import sHeader from '@/components/header'
import sFooter from '@/components/footer'
import sCopyRight from '@/components/copy-right'
import { policyDetail } from '@/api';
import { utf8to16 } from '@/utils/utf8to16';
export default {
  name: 'policyDetail',
  components:{
	sHeaderTop,
	sHeader,
	sFooter,
	sCopyRight
  },  
  data () {
    return {
		id: '',
		item: {
			title:'',//标题
			source:'',//来源
			publishdate:'',//发布时间
			keyword:'',//关键词
			info:'',//内容
			files:''//附件
		}
    }
  },
  mounted(option) {
	this.id = this.$route.query.id,  //接受参数关键代码
	this.getPolicyDetail(this.id)
  },
  methods:{
	getPolicyDetail(id){
		let _this = this
		policyDetail({
		  id: id
		}).then(res=> {
			_this.item = res.data
			
			//富文本中图片大小处理
			
			
			// const regex = new RegExp('<img', 'gi')
			// _this.item.info = _this.item.info.replace(regex, `<img style="max-width: 100%; height: auto"`);
			
			
			if(_this.item.files){
				_this.item.files = utf8to16(_this.item.files)
			}
		})
	}
  }
}
</script>

<style lang="scss" scoped>


.page_body{
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.name{
	line-height: 40px;
	margin-top: 10px;
	text-align: center;
	color: rgba(16, 16, 16, 1);
	font-size: 24px;
	font-weight: 600;
}
.remark{
	width: 100%;
	
	>>> img{
		width:100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/policy-detail.vue